var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sheet',{staticClass:"pa-6"},_vm._l((_vm.careers),function(career){return _c('item-career',{key:career.id,attrs:{"career":career},on:{"deletedCareer":_vm.deletedCareer}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }